import {
  Integration,
  CreatedPartner,
  NextPartnerCode,
  Partner,
  PartnerCodeAvailability,
  PartnerCreateRequest,
  PartnerInfo,
  Webhook,
  WorkflowStatus,
} from './partnerApiTypes';

export const mockApiToken = 's6djl3Kf4DasdG9kHJ03';

export const mockPartnerInfo: PartnerInfo = {
  partnerName: 'MegaPartner',
  integration: Integration.BASELINKER,
  workflowStatus: WorkflowStatus.ACTIVE,
  b2bSellModeEnabled: false,
};

export const mockPartnerWebhook: Webhook = {
  useWebhook: true,
  webhookUrl: 'https://www.xemel.cz/liftago/sadf987654654asdf',
};

export const mockPartners: Partner[] = [{
  id: 0,
  code: '0000',
  name: 'ProSales, sro',
  integration: 'MPI',
  workflowStatus: WorkflowStatus.ACTIVE,
  marketplaceCountTotal: 1,
  marketplaceCountActive: 1,
  webhook: 'https://prosale.cz/mpi/hook.php',
}, {
  id: 1,
  code: '0002',
  name: 'Shumee',
  integration: 'MPI',
  workflowStatus: WorkflowStatus.DEACTIVATED,
  marketplaceCountTotal: 5,
  marketplaceCountActive: 5,
  webhook: 'https://shum.cz/mpi/hook.php',
},
{
  id: 3,
  code: 'Partner',
  name: 'Partner',
  integration: 'MPI',
  workflowStatus: WorkflowStatus.REGISTRATION,
  marketplaceCountTotal: 5,
  marketplaceCountActive: 5,
  webhook: 'https://shum.cz/mpi/hook.php',
}];

export const mockNextPartnerCode: NextPartnerCode = {
  code: '0003',
};

export function mockPartnerCodeAvailability(code: string): PartnerCodeAvailability {
  const requestedCode = code.trim();

  return { available: !mockPartners.some(partner => partner.code === requestedCode) };
}

export function mockCreatedPartner(request: PartnerCreateRequest): CreatedPartner {
  return {
    code: request.code,
    partnerName: request.partnerName,
    integration: request.integration,
    apiToken: mockApiToken,
  };
}
